// ? Two independent axes. The theme is the light/dark mode every platform already has a notion of —
// ? it matches TradingView's own ThemeName and prefers-color-scheme. The mode is the brand on top of
// ? it. Keeping them apart is what lets a brand be one CSS block instead of one entry per combination.
export const APP_THEMES = ['light', 'dark'] as const;

export const APP_MODES = ['default', 'crypto'] as const;

// ? The names CSS resolves per theme and mode. Adding one here is half the work — it also needs a
// ? declaration in public/index.css, which theme.spec.ts asserts.
export const PALETTE_ROLES = [
  'surface',
  'grid',
  'text',
  'accent',
  'candle-up',
  'candle-down',
  'bid',
  'ask',
  'buy',
  'sell',
  'take-profit',
  'hmr-label',
  'toast-surface',
  'toast-text',
  'toolbar-toggle-active',
] as const;
